<template>
  <div class="container">
    <div class="footer">
      <footer id="footer" class="footer-copyright-area footer-copyright-center">
        <div class="row">
          <div class="copyright-content">
            <div class="copyright-notice" style="padding-bottom: 0px;">
              <div>
                © Alle Inhalte unterliegen dem Urheberrecht | <router-link to="/impressum">Impressum</router-link> | <router-link to="/datenschutzerklaerung">Datenschutzerklärung</router-link>
              </div>
            </div>
            <div class="social-links-footer" style="display: none;">
            </div>

          </div> <!-- copyright-content -->
        </div> <!-- row -->
      </footer> <!-- #footer -->
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { Vue } from 'vue-property-decorator'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #ffffff;
}

div.footer {
  background-color: #018CCDFF;
  color: white;
  display: block;
  box-sizing: border-box;
  padding-bottom: 100px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 60px;
  position: relative;
}
</style>
